let enabled = false;
const data: { [key: string]: string } = {};

try {
	const name = "test";
	const value = "value";

	sessionStorage.setItem(name, value);
	enabled = sessionStorage.getItem(name) === value;
} catch (ex) {
	//
}

export function setItem(name: string, value: string): void {
	if (enabled) {
		try {
			sessionStorage.setItem(name, value);
		} catch (ex) {
			//
		}
	} else {
		data[name] = value;
	}
}

export function getItem(name: string): string {
	if (enabled) {
		try {
			return sessionStorage.getItem(name);
		} catch (ex) {
			return "";
		}
	} else {
		return data[name];
	}
}

export function removeItem(name: string): void {
	if (enabled) {
		try {
			sessionStorage.removeItem(name);
		} catch (ex) {
			//
		}
	} else if (name in data) {
		delete data[name];
	}
}
